import React, { useState, useEffect, useContext } from "react";
import { FaBars, FaCaretDown } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { IconContext } from "react-icons/lib";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavBtn,
  NavBtnLink,
  LoginTitle,
  SvgLogo,
  LoginTitleMiddle,
  FlagDropdown,
  NavLogoFlag,
  NavProfile,
  FlagWrap,
  FlagIconBox,
  FlagPic,
  FlagText,
  FlagCheck,
  ProfileMenuWrap,
  ProfileMenuIcon,
  ProfileMenuPic,
  ProfileMenuText,
  ProfileDropdown,
  NotificationIcon,
  DdItem,
  AddToNumber,
  SellPropButton,
  NavBtnResp,
} from "./NavbarElements";
import logoWlogin from "../../images/menzil-logo.png";
import { animateScroll as scroll } from "react-scroll";
import { Modal } from "../Modal/Modal";
import { Formik, Field, Form } from "formik";
import Input from "../Input";
import moment from "moment";
import {
  LoginHeading,
  LoginButton,
  LoginPara,
  LoginDetails,
  InputLabel,
  SigninWrap,
  SigninText,
  NewAccountText,
  SigninBorder,
  ProfileBox,
  ProfileImg,
  ForgetPara,
  FlagImg,
  ForgePara,
} from "./LoginPopupElements";
import { TermText, ForgetHeading } from "./LoginPopupElements";
import OtpInput from "react-otp-input";
import "react-phone-input-2/lib/style.css";
import PhoneInputComponent from "../PhoneInput";
import axios from "../../axios";
import { toast } from "react-toastify";
import Overlay from "../Overlay";
import { withRouter } from "react-router-dom";
import {
  signUpValidator,
  loginValidator,
  DetailsValidator,
  forgetValidator,
  otpValidator,
  resetOutValidator,
} from "../../utils/validators";
import { connect } from "react-redux";
import { get, isEmpty } from "lodash";
import * as actionTypes from "../../store/actions";

import Select from "../Select";
import "./locationdropdown.css";
import Countdown from "react-countdown";
import profileDemo from "../../images/profile-bg.png";
import FlagIcon from "../../images/flag.png";
import {
  ApprovalBox,
  ApprovalText,
  ApprovalDesc,
  ApprovalDescTwo,
  ApprovalButton,
  PropertyButton,
  WebsiteText,
  MoreWebsiteButton,
  MoreWebsiteText,
  HomeBox,
  NotText,
  PurchaseDesc,
} from "../../pages/MenzillPublicPages/Authentication/SigninElements";
import { DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import TextArea from "../../components/TextArea/TextArea";
import { IoMdArrowDropdown } from "react-icons/io";
import Lottie from "lottie-react";
import ApprovedAnimation from "../../components/LottieAnimation/approved.json";
import HomeAnimation from "../../components/LottieAnimation/home.json";
import RejectedAnimation from "../../components/LottieAnimation/rejected.json";
import growingHome from "../../components/LottieAnimation/growingHome.json";
import IncompleteAnimation from "../../components/LottieAnimation/incomplete.json";
import sadAnimation from "../../components/LottieAnimation/sadAnimation.json";
import FlagUs from "../../images/flag-us.png";
import FlagArabic from "../../images/flag-arabic.png";
import FlagTurkey from "../../images/flag-turkey.png";
import ArSq from "../../images/arSq.png";
import TrSq from "../../images/trSq.png";
import AboutIcon from "../../images/profile/about-icon.svg";
import FaqIcon from "../../images/profile/faq-icon.svg";
import LogoutIcon from "../../images/profile/logout-icon.svg";
import PasswordIcon from "../../images/profile/password-icon.svg";
import PrivacyIcon from "../../images/profile/privacy-icon.svg";
import ProfileIcon from "../../images/userNoBg.png";
import PropertyIcon from "../../images/profile/property-icon.svg";
import SavedIcon from "../../images/profile/saved-icon.svg";
import TermIcon from "../../images/profile/term-icon.svg";
import NotificationBg from "../../images/notificationBg.png";
import ServiceIcon from "../../images/profile/service-area-icon.png";
import PrescriptionIcon from "../../images/profile/presc-icon.png";
import RequestIcon from "../../images/request-icon.png";
import ReactSelect from "react-select";
import { Flex } from "../../components/Common.Styled";
import CustomModal from "../../components/Modal";
import { fetchToken } from "../../utils/firebase";
import { DEF_COORDS } from "../../constants/Statics";
import { postApi_home } from "../../utils/apis";
import "react-toastify/dist/ReactToastify.css";
import { LanguageContext } from "../../utils/language/Language";

const Navbar = (props) => {
  const { userData, setUsers, defaultState, setDefaultState, toggle, history, notificationDataState } = props;

  const [scrollNav, setScrollNav] = useState(false);
  const [bgLogin, setBgLogin] = useState(false);
  const [logoColor, setLogoColor] = useState(logoWlogin);
  const [isLoading, setIsLoading] = useState(false);
  const [otpPhone, setOtpPhone] = useState("");
  const [isForgetiing, setIsForgetting] = useState(false);
  const [deviceToken, setDeviceToken] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState(window.localStorage.getItem("rcml-lang") || "en");
  const { dictionary } = useContext(LanguageContext);

  const [signUpformValues, setSignUpformValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    countryCode: "",
    phone: "",
    password: "",
    confirm_password: "",
    selectUser: "",
    terms_check: false,
    postalCode: "",
    countryName: "",
  });

  const [OTPFormValues, setOtpFormValues] = useState({
    country_code: "",
    mobile_number: "",
    verification_code: "",
  });

  const [loginValues, setLoginValues] = useState({
    country_code: "",
    mobile_number: "",
    password: "",
  });

  const [resetPasswordValues, setResetPasswordValues] = useState({
    country_code: "",
    mobile_number: "",
    password: "",
    confirm_password: "",
  });

  const [detailsValues, setDetailsValues] = useState({
    bio: "",
    address: "",
    license_number: "",
  });

  const [currentUser, setCurrentUser] = useState([]);
  const [dropdownOpen, setOpen] = useState(false);
  const [otpKey, setOtpKey] = useState(0);

  const UserTypes = [
    {
      label: dictionary.menzilString.BUYER,
      value: "BUYER",
    },
    {
      label: dictionary.menzilString.SELLER,
      value: "SELLER",
    },
    {
      label: dictionary.menzilString.AGENT,
      value: "AGENT",
    },
  ];

  const Completionist = () => (
    <a
      onClick={() => {
        setOtpKey(otpKey + 1);
        sendOTP(otpPhone, true);
      }}
      href="javascript:void()"
    >
      {dictionary.menzilString.Resend_OTP}
    </a>
  );

  const changeNavOnScroll = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavOnScroll);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const readUnread = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.put("/read-notifications");

      // console.log(data);
      history.push("/notification");
      loadProperties({ currentPos, propertyType });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  // Notification Count
  const [currentPos, setCurrentPos] = useState(DEF_COORDS);
  const [propertyType, setPropertyType] = useState("");
  const [noteCount, setNoteCount] = useState([]);

  useEffect(() => {
    getCurrentPos();
  }, []);

  useEffect(() => {
    currentPos && propertyType && loadProperties({ currentPos, propertyType });
  }, [currentPos, propertyType]);

  const getCurrentPos = () => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setCurrentPos({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
    });
  };
  useEffect(() => {
    fetchToken(setDeviceToken);
  }, [deviceToken]);
  useEffect(() => {
    loadProperties({ currentPos, propertyType });
  }, [notificationDataState]);

  const loadProperties = async ({ currentPos, propertyType }) => {
    try {
      const resData = await postApi_home({ coords: currentPos, propertyType });
      setNoteCount(get(resData, "data.notification_count", 0));
      // console.log(resData);
    } catch (err) {
      console.log(err);
      toast.error(dictionary.menzilString.Cannot_load_properties);
    }
  };
  const loginBox = (
    <>
      {!userData ? (
        <>
          <NavBtn>
            <NavBtnLink to={props.location} onClick={() => setDefaultState({ isSignup: false, isLogin: true })}>
              {dictionary.menzilString.Sell_your_property}
            </NavBtnLink>
            <NavBtnLink to="/" primary="true" onClick={() => setDefaultState({ isSignup: false, isLogin: true })}>
              {dictionary.menzilString.Signin}
            </NavBtnLink>
          </NavBtn>
        </>
      ) : (
        <>
          <NavBtn>
            {/* {userData.role !== "BUYER" && (
              <>
                {userData?.is_approve === "2" || userData?.is_approve === "3" ? (
                  <NavBtnLink
                    to={props.location}
                    onClick={() => {
                      setDefaultState({
                        isAgentApprove: true,
                      });
                    }}
                  >
                    {dictionary.menzilString.Sell_your_property}
                  </NavBtnLink>
                ) : userData?.is_approve === "1" &&
                  userData.role === "AGENT" &&
                  isEmpty(userData.prescription) &&
                  userData?.settings?.is_subscription_enable ? (
                  <NavBtnLink
                    to={props.location}
                    onClick={() => {
                      setDefaultState({
                        isAgentPrescription: true,
                      });
                    }}
                  >
                    {dictionary.menzilString.Sell_your_property}
                  </NavBtnLink>
                ) : (
                  <SellPropButton
                    onClick={() => {
                      const prescStat = handlePrescription();
                      if (!prescStat && userData.role === "AGENT" && userData?.settings?.is_subscription_enable) {
                        setDefaultState({
                          isAgentPrescription: true,
                        });
                      } else {
                        history.push("/post-property");
                      }
                    }}
                  >
                    {dictionary.menzilString.Sell_your_property}
                  </SellPropButton>
                )}
              </>
            )} */}
            {userData.role !== "BUYER" && (
              <>
                {userData?.is_approve === "2" || userData?.is_approve === "3" ? (
                  <NavBtnLink
                    to={props.location}
                    onClick={() => {
                      setDefaultState({
                        isAgentApprove: true,
                      });
                    }}
                  >
                    {dictionary.menzilString.Sell_your_property}
                  </NavBtnLink>
                ) : (
                  <SellPropButton
                    onClick={() => {
                      history.push("/post-property");
                    }}
                  >
                    {dictionary.menzilString.Sell_your_property}
                  </SellPropButton>
                )}
              </>
            )}
            {userData?.is_approve === "2" || userData?.is_approve === "3" ? (
              <>
                {!history.location.pathname === "/agent-profile" ? (
                  <div style={{ cursor: "pointer" }} onClick={readUnread}>
                    <NotificationIcon src={NotificationBg} />
                    <AddToNumber
                      style={{ display: noteCount > 0 ? "block" : "none", padding: noteCount > 9 ? "3px 6px" : "4px 10px" }}
                    >
                      {noteCount}
                    </AddToNumber>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <UncontrolledDropdown setActiveFromChild>
                    <DropdownToggle
                      onClick={() => {
                        currentUserFun();
                      }}
                      tag="a"
                      className="nav-link"
                    >
                      <NavProfile to="">
                        <ProfileBox>
                          <ProfileImg src={profileDemo} />
                        </ProfileBox>
                        <IoMdArrowDropdown style={{ color: "black" }} />
                      </NavProfile>
                    </DropdownToggle>
                    <DropdownMenu className="dropmenu-profile">
                      <>
                        {userData.agent_profile ? (
                          <>
                            {!(history.location.pathname === "/agent-profile") ? (
                              <>
                                <DdItem
                                  onClick={() => {
                                    handleAgentStatus();
                                  }}
                                >
                                  <ProfileMenuWrap>
                                    <ProfileMenuIcon>
                                      <ProfileMenuPic src={AboutIcon} />
                                      <ProfileMenuText>{dictionary.menzilString.Check_Status}</ProfileMenuText>
                                    </ProfileMenuIcon>
                                  </ProfileMenuWrap>
                                </DdItem>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <>
                            {!(history.location.pathname === "/agent-profile") ? (
                              <>
                                <DdItem
                                  onClick={() => {
                                    history.push("/agent-profile");
                                  }}
                                >
                                  <ProfileMenuWrap>
                                    <ProfileMenuIcon>
                                      <ProfileMenuPic src={AboutIcon} />
                                      <ProfileMenuText> {dictionary.menzilString.Complete_Profile}</ProfileMenuText>
                                    </ProfileMenuIcon>
                                  </ProfileMenuWrap>
                                </DdItem>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </>

                      <DdItem
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        <ProfileMenuWrap>
                          <ProfileMenuIcon>
                            <ProfileMenuPic src={LogoutIcon} />
                            <ProfileMenuText>{dictionary.menzilString.Logout}</ProfileMenuText>
                          </ProfileMenuIcon>
                        </ProfileMenuWrap>
                      </DdItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
            ) : (
              ""
            )}

            {userData?.is_approve === "1" ? (
              <>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (history.location.pathname === "/post-property") {
                      const result = window.confirm(dictionary.menzilString.Your_data_will_be_lost);
                      if (result == true) {
                        readUnread();
                      }
                    } else {
                      readUnread();
                    }
                  }}
                >
                  <NotificationIcon src={NotificationBg} />
                  <AddToNumber
                    style={{ display: noteCount > 0 ? "block" : "none", padding: noteCount > 9 ? "3px 6px" : "4px 10px" }}
                  >
                    {noteCount}
                  </AddToNumber>
                </div>
                <div>
                  <UncontrolledDropdown setActiveFromChild>
                    <DropdownToggle
                      onClick={(e) => {
                        currentUserFun();
                        if (history.location.pathname === "/post-property") {
                          const result = window.confirm(dictionary.menzilString.Your_data_will_be_lost);
                        }
                      }}
                      tag="a"
                      className="nav-link"
                    >
                      <NavProfile to="">
                        <ProfileBox>
                          <ProfileImg src={userData.profile_picture ? userData.profile_picture : profileDemo} />
                        </ProfileBox>
                        <IoMdArrowDropdown style={{ color: "black" }} />
                      </NavProfile>
                    </DropdownToggle>
                    <DropdownMenu className="dropmenu-profile">
                      {userData?.role === "AGENT" ? (
                        <DdItem
                          onClick={() => {
                            history.push("/manage-service-area");
                          }}
                        >
                          <ProfileMenuWrap style={{ background: "#15396D" }}>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={ServiceIcon} />
                              <ProfileMenuText style={{ color: "white" }}>
                                {dictionary.menzilString.Manage_Service_Area}
                              </ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}
                      <DdItem
                        onClick={() => {
                          userData?.role === "AGENT" ? history.push("/profile") : history.push("/my-profile");
                        }}
                        disabled={userData?.role === "GUEST"}
                      >
                        <ProfileMenuWrap>
                          <ProfileMenuIcon>
                            <ProfileMenuPic src={ProfileIcon} />
                            <ProfileMenuText>{dictionary.menzilString.My_Profile}</ProfileMenuText>
                          </ProfileMenuIcon>
                        </ProfileMenuWrap>
                      </DdItem>
                      {userData?.role === "AGENT" ? (
                        <DdItem
                          onClick={() => {
                            history.push("/property-request");
                          }}
                        >
                          <ProfileMenuWrap>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={RequestIcon} />
                              <ProfileMenuText>{dictionary.menzilString.Requests}</ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}
                      {userData?.role === "AGENT" && userData?.settings?.is_subscription_enable ? (
                        <DdItem
                          onClick={() => {
                            history.push("/prescription");
                          }}
                        >
                          <ProfileMenuWrap>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={PrescriptionIcon} />
                              <ProfileMenuText>{dictionary.menzilString.Prescription_Plan}</ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}

                      {userData?.role === "AGENT" || userData?.role === "SELLER" ? (
                        <DdItem onClick={() => history.push("/my-properties")}>
                          <ProfileMenuWrap>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={PropertyIcon} />
                              <ProfileMenuText>{dictionary.menzilString.Manage_Properties}</ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}

                      {userData?.role === "BUYER" || userData?.role === "GUEST" ? (
                        <DdItem onClick={() => history.push("/save-property")} disabled={userData?.role === "GUEST"}>
                          <ProfileMenuWrap>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={PropertyIcon} />
                              <ProfileMenuText>{dictionary.menzilString.Saved_Properties}</ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}

                      {userData?.role !== "GUEST" ? (
                        <DdItem onClick={() => history.push("/change-password")}>
                          <ProfileMenuWrap>
                            <ProfileMenuIcon>
                              <ProfileMenuPic src={PasswordIcon} />
                              <ProfileMenuText>{dictionary.menzilString.Change_Password}</ProfileMenuText>
                            </ProfileMenuIcon>
                          </ProfileMenuWrap>
                        </DdItem>
                      ) : (
                        ""
                      )}

                      <DdItem
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        <ProfileMenuWrap>
                          <ProfileMenuIcon>
                            <ProfileMenuPic src={LogoutIcon} />
                            <ProfileMenuText>{dictionary.menzilString.Logout}</ProfileMenuText>
                          </ProfileMenuIcon>
                        </ProfileMenuWrap>
                      </DdItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
            ) : (
              ""
            )}
          </NavBtn>
        </>
      )}
    </>
  );

  const MenuBox = (
    <>
      <NavMenu>
        <NavItem>
          <NavLinks
            style={{
              color: history.location.pathname === "/" ? "#ED7D2B" : "",
              borderBottom: history.location.pathname === "/" ? "3px solid #ED7D2B" : "",
            }}
            onClick={() => {
              if (history.location.pathname === "/post-property") {
                const result = window.confirm(dictionary.menzilString.Your_data_will_be_lost);
                if (result == true) {
                  history.push("/");
                }
              } else {
                history.push("/");
              }
            }}
          >
            {dictionary.menzilString.Home}
          </NavLinks>
        </NavItem>
        <NavItem>
          <NavLinks
            style={{
              color: history.location.pathname === "/postal-codes" ? "#ED7D2B" : "",
              borderBottom: history.location.pathname === "/postal-codes" ? "3px solid #ED7D2B" : "",
            }}
            onClick={() => {
              history.push("/postal-codes");
            }}
          >
            {dictionary.menzilString.Zipcodes}
          </NavLinks>
        </NavItem>
        {/* <NavItem>
          <NavLinks to="add_a_restaurant">{dictionary.menzilString.Services}</NavLinks>
        </NavItem> */}
        {/* <NavItem>
          <NavLinks to="add_a_restaurant">About Us</NavLinks>
        </NavItem> */}
        <NavItem>
          <NavLinks
            style={{
              color: history.location.pathname === "/search-property" ? "#ED7D2B" : "",
              borderBottom: history.location.pathname === "/search-property" ? "3px solid #ED7D2B" : "",
            }}
            onClick={() => {
              if (!userData) {
                setDefaultState({ isSignup: false, isLogin: true });
              } else {
                if (history.location.pathname === "/post-property") {
                  const result = window.confirm(dictionary.menzilString.Your_data_will_be_lost);
                  if (result == true) {
                    history.push(`/search-property?lat=${currentPos.lat}&long=${currentPos.lng}&sale_type=1&property_type=`);
                  }
                } else {
                  history.push(`/search-property?lat=${currentPos.lat}&long=${currentPos.lng}&sale_type=1&property_type=`);
                }
              }
            }}
          >
            {dictionary.menzilString.Properties}
          </NavLinks>
        </NavItem>
        <NavLinks
          style={{
            color: history.location.pathname === "/agent-finder" ? "#ED7D2B" : "",
            borderBottom: history.location.pathname === "/agent-finder" ? "3px solid #ED7D2B" : "",
          }}
          onClick={() => {
            if (!userData) {
              setDefaultState({ isSignup: false, isLogin: true });
            } else {
              if (history.location.pathname === "/post-property") {
                const result = window.confirm(dictionary.menzilString.Your_data_will_be_lost);
                if (result == true) {
                  history.push(`/agent-finder?lat=${currentPos.lat}&long=${currentPos.lng}`);
                }
              } else {
                history.push(`/agent-finder?lat=${currentPos.lat}&long=${currentPos.lng}`);
              }
            }
          }}
        >
          {dictionary.menzilString.Agent_Finder}
        </NavLinks>
        {/* <NavItem>
          <NavLinks to="contact">Contact Us</NavLinks>
        </NavItem> */}
      </NavMenu>
    </>
  );

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span>
          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };

  // ***************Menzil Authentication module*******************

  useEffect(() => {
    currentUserFun();
  }, []);

  const currentUserFun = async () => {
    const { data } = await axios.get("/current-user");
    const { data: data2 } = await axios.get("/setting");
    const finalData = { ...data.data, settings: data2.data };
    setCurrentUser(finalData);
    localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
    setUsers(finalData);
  };

  // Approve: 1, inprogress: 2 , Disapprove: 3,
  const handleAgentStatus = async () => {
    if (currentUser?.is_approve === "1") {
      setDefaultState({
        isApproval: true,
      });
    } else if (currentUser?.is_approve === "2") {
      setDefaultState({
        isProcess: true,
      });
    } else if (currentUser?.is_approve === "3") {
      setDefaultState({
        isDisapprove: true,
      });

      // setDefaultState((prevState) => {
      //   return {
      //     ...prevState,
      //     isDisapprove: true,
      //   };
      // })
    }
  };

  const handleSignUP = async (values) => {
    setIsLoading(true);

    var formvalues = {
      first_name: values.first_name,
      last_name: values.last_name,
      countryName: values.countryName,
      email: values.email,
      country_code: values.countryCode,
      phone_number: values.phone,
      password: values.password,
      postalCode: values.postalCode,
      device_token: deviceToken ? deviceToken : "SDFsldfji@#@$334234sfsyu",
      role: values.selectUser.value,
      language: "en",
      device_type: "Web",
    };

    try {
      const { data } = await axios.post("/signup", formvalues);
      setOtpFormValues({
        country_code: values.countryCode,
        mobile_number: values.phone,
      });
      // localStorage.setItem("MenzilAccessToken", data.access_token);
      // localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
      // localStorage.setItem("isMenzilUser", true);
      // setUsers(data.data);
      setOtpPhone({
        country_code: values.countryCode,
        mobile_number: values.phone,
      });
      setIsLoading(false);
      // toast.success(`${data.message}`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      setDefaultState({
        isOtp: true,
        isApproval: false,
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      // setSignUpformValues({
      //   first_name: "",
      //   last_name: "",
      //   email: "",
      //   countryCode: "",
      //   mobile_number: "",
      //   password: "",
      //   confirm_password: "",
      //   selectUser: "",
      // });
      if (error.response.status === 401) {
        localStorage.removeItem("MenzilAccessToken");
        localStorage.removeItem("MenzilUserData");
        //window.location.pathname = "/";
      }
    }
  };

  const sendOTP = async (values, forget = false) => {
    setIsLoading(true);

    // setDefaultState((prevState) => {
    //   return {
    //     ...prevState,
    //     isOtp: false
    //   };
    // });

    try {
      const { data } = await axios.post("/send-otp", {
        country_code: values.country_code,
        phone_number: values.mobile_number,
      });

      setOtpPhone({
        country_code: values.country_code,
        mobile_number: values.mobile_number,
      });

      // toast.success(`${data.message}`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      setDefaultState({
        isOtp: true,
        isApproval: false,
      });
      if (forget) {
        setIsForgetting(true);
      }

      setOtpFormValues({
        country_code: values.country_code,
        mobile_number: values.mobile_number,
        verification_code: "",
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (forget) {
        setDefaultState({
          isSignup: false,
          isLogin: false,
          isForget: true,
        });
      } else {
        setDefaultState({
          isSignup: true,
          isLogin: false,
        });
      }
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        //window.location.pathname = "/";
      }
    }
  };

  const sendForgetOTP = async (values, forget = false) => {
    setIsLoading(true);

    try {
      const { data } = await axios.post("/send-otp", {
        country_code: values.country_code,
        phone_number: values.mobile_number,
      });

      setOtpPhone({
        country_code: values.country_code,
        mobile_number: values.mobile_number,
      });

      // toast.success(`${data.message}`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      setDefaultState({
        isForgetOtp: true,
        isApproval: false,
      });
      if (forget) {
        setIsForgetting(true);
      }

      setOtpFormValues({
        country_code: values.country_code,
        mobile_number: values.mobile_number,
        verification_code: "",
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (forget) {
        setDefaultState({
          isSignup: false,
          isLogin: false,
          isForget: true,
        });
      } else {
        setDefaultState({
          isSignup: true,
          isLogin: false,
        });
      }
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        //window.location.pathname = "/";
      }
    }
  };

  const verifyOTP = async (values) => {
    setIsLoading(true);
    setOtpFormValues(values);

    setIsLoading(true);
    try {
      const { data } = await axios.post("/verify-otp", {
        country_code: values.country_code,
        phone_number: values.mobile_number,
        otp: values.verification_code,
        device_type: "Web",
        device_token: deviceToken ? deviceToken : "SDFsldfji@#@$334234sfsyu",
      });

      setIsLoading(false);
      setDefaultState({
        isOtp: true,
      });

      if (data.data.is_verified) {
        if (data.data.role === "AGENT") {
          setDefaultState({
            isOtp: false,
          });

          history.push("/agent-profile");
          // setDefaultState((prevState) => {
          //   return {
          //     ...prevState,
          //     isProcess : true,
          //     isOtp: false
          //   };
          // });

          // setDefaultState({
          //   isProcess: true,
          //   isOtp: false,
          // });

          localStorage.setItem("MenzilAccessToken", data.access_token);
          localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
          localStorage.setItem("isMenzilUser", true);
          setUsers(data.data);
        } else {
          setDefaultState((prevState) => {
            return {
              ...prevState,
              isOtp: false,
            };
          });

          localStorage.setItem("MenzilAccessToken", data.access_token);
          localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
          localStorage.setItem("isMenzilUser", true);
          setUsers(data.data);
          history.push("/");
        }
      } else {
        setOtpFormValues({
          countryCode: values.countryCode,
          mobileNumber: values.mobileNumber,
        });
        setOtpPhone({
          countryCode: values.countryCode,
          mobileNumber: values.mobileNumber,
        });
        setIsLoading(false);
        setDefaultState({
          isOtp: true,
          isApproval: false,
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.status === 401) {
        localStorage.removeItem("MenzilAccessToken");
        localStorage.removeItem("MenzilUserData");
      }
      setDefaultState({
        isOtp: true,
        isApproval: false,
      });
    }
  };

  const forgetVerifyOTP = async (values) => {
    setIsLoading(true);
    setOtpFormValues(values);

    setIsLoading(true);
    try {
      const { data } = await axios.post("/verify-otp", {
        country_code: values.country_code,
        phone_number: values.mobile_number,
        otp: values.verification_code,
        device_type: "Web",
        device_token: deviceToken ? deviceToken : "SDFsldfji@#@$334234sfsyu",
      });

      setIsLoading(false);

      if (data.data.is_verified) {
        setLoginValues({
          country_code: values.country_code,
          mobile_number: values.mobile_number,
          password: "",
        });

        setResetPasswordValues({
          country_code: values.country_code,
          mobile_number: values.mobile_number,
          password: "",
          confirm_password: "",
        });

        setDefaultState({
          isOtp: false,
          isReset: true,
        });
      } else {
        setOtpFormValues({
          countryCode: values.countryCode,
          mobileNumber: values.mobileNumber,
        });
        setOtpPhone({
          countryCode: values.countryCode,
          mobileNumber: values.mobileNumber,
        });
        setIsLoading(false);
        setDefaultState({
          isOtp: true,
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.status === 401) {
        localStorage.removeItem("MenzilAccessToken");
        localStorage.removeItem("MenzilUserData");
      }
      setDefaultState({
        isOtp: true,
        isApproval: false,
      });
    }
  };

  const handleDetails = async (values) => {
    setIsLoading(true);
    var url = "/agent-profile";
    var formvalues = {
      bio: values.bio,
      address: values.address,
      license_number: values.license_number,
      website: [
        {
          name: "instagram",
          url: "https://www.instagram.com",
        },
        {
          name: "Facebook",
          url: "https://www.facebook.com",
        },
        {
          name: "Twitter",
          url: "https://www.twitter.com",
        },
      ],
    };

    try {
      const { data } = await axios.post(url, formvalues);

      setIsLoading(false);

      setDefaultState((prevState) => {
        return {
          ...prevState,
          isDetails: false,
          isProcess: true,
        };
      });
    } catch (error) {
      setIsLoading(false);

      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.status === 401) {
        localStorage.removeItem("MenzilAccessToken");
        localStorage.removeItem("MenzilUserData");
        //window.location.pathname = "/";
      }
    }
  };

  const handleReset = async (values) => {
    // setLoginValues(values);
    setResetPasswordValues(values);
    setIsLoading(true);
    setDefaultState((prevState) => {
      return {
        ...prevState,
        isReset: false,
      };
    });

    try {
      const { data } = await axios.post("/reset-password", {
        country_code: values.country_code,
        phone_number: values.mobile_number,
        password: values.password,
      });
      // toast.success(`${data.message}`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });

      setIsLoading(false);
      // history.push('/');
      localStorage.removeItem("MenzilAccessToken");
      localStorage.removeItem("MenzilUserData");
      setUsers(data.response);
    } catch (error) {
      setIsLoading(false);
      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.status === 401) {
        history.push("/");
        localStorage.removeItem("MenzilAccessToken");
        localStorage.removeItem("MenzilUserData");
        // setUsers("");
      }
    }
  };

  const handleLogin = async (values, isSocial = false) => {
    setLoginValues(values);
    setIsLoading(true);

    // setDefaultState((prevState) => {
    //   return {
    //     ...prevState,
    //     isLogin: false,
    //   };
    // });

    var url = "/login";
    var formvalues = {
      country_code: values.country_code,
      phone_number: values.mobile_number,
      password: values.password,
      device_token: deviceToken ? deviceToken : "SDFsldfji@#@$334234sfsyu",
      device_type: "Web",
    };

    try {
      const { data } = await axios.post(url, formvalues);

      if (data.data.is_verified) {
        setDefaultState({
          isLogin: false,
        });

        localStorage.setItem("MenzilAccessToken", data.access_token);
        localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
        localStorage.setItem("isMenzilUser", true);
        setUsers(data.data);

        if (data.data.role === "AGENT") {
          if (!data.data.agent_profile) {
            history.push("/agent-profile");
            // history.push("/webPanel");
          } else if (data.data.is_approve === "1") {
            if (isEmpty(data.data.prescription)) {
              history.push("/prescription");
            } else {
              history.push("/");
            }
          } else {
            history.push("/");
          }
        } else {
          history.push("/");
        }
      } else {
        setOtpFormValues({
          country_code: values.country_code,
          mobile_number: values.mobile_number,
        });
        sendOTP({
          country_code: values.country_code,
          mobile_number: values.mobile_number,
        });
      }
      setIsLoading(false);
      // window.location.reload();
    } catch (error) {
      setIsLoading(false);

      toast.error(`${error.response.data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      setLoginValues({
        country_code: values.country_code,
        mobile_number: values.mobile_number,
        password: "",
      });

      if (error.response.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        //window.location.pathname = "/";
      }
    }
  };

  const guestLogin = async (values) => {
    // setLoginValues(values);
    setIsLoading(true);
    var url = "/login-anonymous";
    var formvalues = {
      device_token: "Xy65bj544bkemld",
      device_type: "Web",
    };

    try {
      const { data } = await axios.post(url, formvalues);

      if (data.data) {
        localStorage.setItem("MenzilAccessToken", data.access_token);
        localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
        localStorage.setItem("isMenzilUser", true);
        setUsers(data.data);

        setDefaultState({
          isLogin: false,
        });

        // history.push("/");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      toast.error(`${error?.response?.data?.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        //window.location.pathname = "/";
      }
    }
  };

  const handleLogout = () => {
    handleConfirm();
  };

  // const handleConfirm = async () => {
  //   if (window.confirm(dictionary.menzilString.Are_you_sure_you_want_to_Logout)) {
  //     try {
  //       let { data } = await axios.post("/logout");
  //     } catch (err) {}
  //     localStorage.removeItem("MenzilAccessToken");
  //     localStorage.removeItem("MenzilUserData");
  //     localStorage.removeItem("isMenzilUser");
      
  //     setUsers("");
  //     // setUsers("");
  //     localStorage.setItem("MenzilLogout", Date.now());
  //     history.push("/");
  //     // history.go("0");
  //   }
  // };
  
  const handleConfirm = async () => {
    if (window.confirm(dictionary.menzilString.Are_you_sure_you_want_to_Logout)) {
      try {
        await axios.post("/logout");
      } catch (err) {
        console.error("Logout error:", err);
      }
  
      // Remove user data
      localStorage.removeItem("MenzilAccessToken");
      localStorage.removeItem("MenzilUserData");
      localStorage.removeItem("isMenzilUser");
  
      // Broadcast logout event
      localStorage.setItem("MenzilLogout", Date.now());
  
      // Clear React state
      setUsers(null);
  
      // Redirect to home
      history.push("/");
    }
  };
  

  const handlePrescription = () => {
    const expDate = moment(userData?.prescription?.expire_plan);
    var currDate = moment().utc();
    var d = expDate.diff(currDate, "days");
    if (d > 0) {
      return true;
    } else if (d < 0) {
      return false;
    }
  };

  const capitalize = (s) => {
    if (s) {
      return s[0]?.toUpperCase() + s?.slice(1);
    } else {
      return "";
    }
  };

  const handleBackdropClick = (event) => {
    //these fail to keep the modal open
    event.stopPropagation();
    return false;
  };

  useEffect(() => {
    fetchToken(setDeviceToken);
  }, [deviceToken]);

  //localization
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const handleLanguageChange = (value) => userLanguageChange(value);
  const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";
  // const { dictionary } = useContext(LanguageContext);
  // console.log(deviceToken);

  const handlePropertyAlert = () => {
    // console.log("heeeeeeeeeeeeeeeee");
    // console.log(history.location.pathname);
    if (history.location.pathname === "/post-property") {
      alert(dictionary.menzilString.Your_data_will_be_lost);
    }
  };

  const [countryList, setCountryList] = useState("");
  const [postalCodeList, setPostalCodeList] = useState("");
  const [countryName, setCountryName] = useState("");
  // console.log("countryNAme",countryName)
  // console.log("countryList",countryList)

  const getCountrylist = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get("/country-list");
      const _country = data?.data?.map((item) => ({
        label: item.country,
        value: item.country,
      }));
      setCountryList(_country);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const getPostalCodeList = async (countryName) => {
    console.log("countryName", countryName);
    setIsLoading(true);
    try {
      const { data } = await axios.get(`/postalCode?country=${countryName}`);
      const _postalCode = data?.data?.map((item) => ({
        label: item.zip_code,
        value: item.zip_code,
      }));
      setPostalCodeList(_postalCode);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getCountrylist();
  }, []);

  useEffect(() => {
    getPostalCodeList(countryName);
  }, [countryName]);

  // console.log("userLanguage", userLanguage);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav} bgLogin={bgLogin}>
          <NavbarContainer>
            <NavLogoFlag>
              <MobileIcon onClick={toggle}>
                <FaBars style={{ color: "#fffff" }} />
              </MobileIcon>
              <NavLogo to="/" onClick={toggleHome}>
                <SvgLogo className="logoImage" src={logoColor} />
              </NavLogo>
              <FlagDropdown>
                <UncontrolledDropdown setActiveFromChild>
                  <DropdownToggle
                    onClick={() => {
                      currentUserFun();
                    }}
                    tag="a"
                    className="nav-link"
                  >
                    <NavLinks to="">
                      <ProfileBox>
                        {/* <FlagImg
                          src={
                            selectedLanguage === "en"
                              ? FlagIcon
                              : selectedLanguage === "ar"
                                ? TrSq
                                : selectedLanguage === "tr"
                                  ? ArSq
                                  : FlagUs
                          }
                        /> */}
                        {selectedLanguage === "en"
                          ? "English"
                          : selectedLanguage === "ar"
                          ? "عربي"
                          : selectedLanguage === "tr"
                          ? "Türkçe"
                          : "Select Language"}
                      </ProfileBox>
                      <IoMdArrowDropdown style={{ marginLeft: "10px", color: "black" }} />
                    </NavLinks>
                  </DropdownToggle>
                  <DropdownMenu className="dropmenu-flag">
                    <DropdownItem>
                      <FlagWrap
                        onClick={(event) => {
                          setSelectedLanguage("en");
                          handleLanguageChange("en");
                        }}
                      >
                        <FlagIconBox>
                          {/* <FlagPic src={FlagUs} /> */}
                          <FlagText>English</FlagText>
                        </FlagIconBox>
                        <FlagCheck>
                          {selectedLanguage === "en" && (
                            <Input
                              onClick={(event) => {
                                setSelectedLanguage("en");
                                handleLanguageChange("en");
                              }}
                              type="checkbox"
                              checked={true}
                              className="checkboxLanguage"
                              readOnly
                            />
                          )}
                        </FlagCheck>
                      </FlagWrap>
                    </DropdownItem>
                    <DropdownItem>
                      <FlagWrap
                        onClick={(event) => {
                          setSelectedLanguage("ar");
                          handleLanguageChange("ar");
                        }}
                      >
                        <FlagIconBox>
                          {/* <FlagPic src={FlagArabic} /> */}
                          <FlagText>عربي</FlagText>
                        </FlagIconBox>
                        <FlagCheck>
                          {selectedLanguage === "ar" && (
                            <Input
                              onClick={(event) => {
                                setSelectedLanguage("ar");
                                handleLanguageChange("ar");
                              }}
                              // event.stopPropagation();
                              type="checkbox"
                              checked={true}
                              className="checkboxLanguage"
                              readOnly
                            />
                          )}
                        </FlagCheck>
                      </FlagWrap>
                    </DropdownItem>
                    <DropdownItem>
                      <FlagWrap
                        onClick={(event) => {
                          setSelectedLanguage("tr");
                          handleLanguageChange("tr");
                        }}
                      >
                        <FlagIconBox>
                          {/* <FlagPic src={FlagTurkey} /> */}
                          <FlagText>Türkçe</FlagText>
                        </FlagIconBox>
                        <FlagCheck>
                          {selectedLanguage === "tr" && (
                            <Input
                              onClick={(event) => {
                                setSelectedLanguage("tr");
                                handleLanguageChange("tr");
                              }}
                              // event.stopPropagation();
                              type="checkbox"
                              checked={true}
                              className="checkboxLanguage"
                              readOnly
                            />
                          )}
                        </FlagCheck>
                      </FlagWrap>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </FlagDropdown>
            </NavLogoFlag>
            {MenuBox}
            {loginBox}
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>

      {/* Menzil Authentication  Module */}

      {/* Process Modal */}
      <Modal
        maxWidth="xs"
        noDialogPadding={true}
        isOpen={defaultState.isProcess}
        // onClose={() => {
        //   setDefaultState({
        //     isProcess: false
        //   });
        // }}
        title={
          <LoginTitle>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  history.push("/");
                  setDefaultState({
                    isProcess: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <ApprovalBox>
            <Lottie
              animationData={HomeAnimation}
              loop={true}
              //  style={ {width : '50%'}}
            />
            <ApprovalText>{dictionary.menzilString.Your_application_is_in_process}</ApprovalText>
            <ApprovalDesc> {dictionary.menzilString.Kindly_wait_for_Admin_approval}</ApprovalDesc>
            <ApprovalDescTwo> {dictionary.menzilString.usually_take_2448_hours}</ApprovalDescTwo>
            <ApprovalButton
              onClick={() => {
                history.push("/");
                setDefaultState({
                  isApproval: false,
                });
              }}
            >
              <LoginButton>{dictionary.menzilString.Go_to_Homepage}</LoginButton>
            </ApprovalButton>
          </ApprovalBox>
        }
      />

      {/* Approval Modal */}
      <Modal
        maxWidth="xs"
        noDialogPadding={true}
        isOpen={defaultState.isApproval}
        // onClose={() => {
        //   setDefaultState({
        //     isApproval: false
        //   });
        // }}
        title={
          <LoginTitle>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isApproval: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <ApprovalBox>
            <Lottie
              animationData={ApprovedAnimation}
              loop={true}
              style={{ width: "50%" }}
              //  height={800}
              // width={50}
            />
            {/* <ApprovalImg src={approved}/> */}
            <ApprovalText>{dictionary.menzilString.Your_application_is_Approved}</ApprovalText>
            <ApprovalButton
              onClick={() => {
                history.push("/prescription");
                setDefaultState({
                  isApproval: false,
                });
              }}
            >
              <LoginButton>{dictionary.menzilString.Continue}</LoginButton>
            </ApprovalButton>
          </ApprovalBox>
        }
      />

      {/* Disapprove Modal */}
      <Modal
        maxWidth="xs"
        noDialogPadding={true}
        isOpen={defaultState.isDisapprove}
        // onClose={() => {
        //   setDefaultState({
        //     isDisapprove: false
        //   });
        // }}
        title={
          <LoginTitle>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isDisapprove: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <ApprovalBox>
            <Lottie animationData={RejectedAnimation} loop={true} style={{ width: "32%" }} />
            <ApprovalText style={{ marginTop: "2rem" }}>{dictionary.menzilString.Your_application_is_Rejected}</ApprovalText>
            <ApprovalDesc>{dictionary.menzilString.Please_check_your_details}</ApprovalDesc>
            <ApprovalButton>
              <LoginButton
                onClick={() => {
                  setDefaultState({
                    isDisapprove: false,
                  });
                  history.push("/agent-profile");
                }}
              >
                {dictionary.menzilString.Check_your_details}
              </LoginButton>
            </ApprovalButton>
          </ApprovalBox>
        }
      />

      {/* Agent Approve Modal */}
      <Modal
        maxWidth="xs"
        noDialogPadding={true}
        isOpen={defaultState.isAgentApprove}
        onClose={() => {
          setDefaultState({
            isAgentApprove: false,
          });
        }}
        title={
          <LoginTitle>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isAgentApprove: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <ApprovalBox>
            <Lottie animationData={IncompleteAnimation} loop={true} style={{ width: "32%" }} />
            <ApprovalText style={{ marginTop: "2rem" }}>{dictionary.menzilString.Sorry_for_inconvenience}</ApprovalText>
            <ApprovalDesc>{dictionary.menzilString.Your_application_is_not_approved}</ApprovalDesc>
          </ApprovalBox>
        }
      />

      {/* Sell Property Modal */}
      <Modal
        maxWidth="xs"
        noDialogPadding={false}
        isOpen={defaultState.isSellProperty}
        onClose={() => {
          setDefaultState({
            isSellProperty: false,
          });
        }}
        title={
          <LoginTitleMiddle>
            <LoginTitle style={{ fontSize: "1.5rem" }}>
              {dictionary.menzilString.Post_a_Property}
              <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
                <AiOutlineClose
                  style={{ fontSize: "1.5rem" }}
                  onClick={() => {
                    setDefaultState({
                      isSellProperty: false,
                    });
                  }}
                />
              </div>
            </LoginTitle>
          </LoginTitleMiddle>
        }
        content={
          <ApprovalBox>
            <HomeBox>
              <Lottie animationData={growingHome} loop={true} style={{ width: "50%" }} />
            </HomeBox>
            {/* <ApprovalImg src={approved}/> */}
            <ApprovalButton
              onClick={() => {
                history.push("/post-property");
                setDefaultState({ isSellProperty: false });
              }}
            >
              <LoginButton style={{ color: "#000000", background: "white", border: "1px solid #000000" }}>
                {dictionary.menzilString.Post_add_as_Sale}
              </LoginButton>
            </ApprovalButton>

            <PropertyButton
              onClick={() => {
                history.push("/post-property");
              }}
            >
              <LoginButton>{dictionary.menzilString.Post_add_as_Lease}</LoginButton>
            </PropertyButton>

            <ReactSelect isClearable isSearchable options={["a", "b"]} placeholder="Select Property Type" />
          </ApprovalBox>
        }
      />

      {/* Login profile */}
      <Modal
        maxWidth="md"
        width="460px"
        noDialogPadding={true}
        disableBackdropClick
        backgroundModal={false}
        backgroundModalContent={false}
        isOpen={defaultState.isLogin}
        title={
          <LoginTitleMiddle>
            <LoginHeading>{dictionary.menzilString.Welcome_to_Menzill}</LoginHeading>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isSignup: false,
                    isLogin: false,
                  });
                }}
              />
            </div>
          </LoginTitleMiddle>
        }
        content={
          <>
            <SigninWrap>
              <SigninText
                logintype={defaultState.isLogin}
                onClick={() => {
                  setDefaultState({
                    isLogin: true,
                    isSignup: false,
                  });
                }}
              >
                {/* Sign in */}
                {dictionary.menzilString.Signin}
              </SigninText>
              <NewAccountText
                onClick={() => {
                  setDefaultState({
                    isSignup: true,
                    isLogin: false,
                  });
                }}
              >
                {dictionary.menzilString.New_account}
              </NewAccountText>
            </SigninWrap>
            <SigninBorder></SigninBorder>
            <Formik
              enableReinitialize
              initialValues={loginValues}
              validate={(vals) => loginValidator(vals, dictionary.menzilString)}
              validateOnChange
              onSubmit={(values) => handleLogin(values, false)}
            >
              {(formikBag) => {
                return (
                  <Form>
                    <div className={"col-md-12 signup_phone" + (defaultLanguage === "ar" ? " tel-arabic" : "")}>
                      <InputLabel>{dictionary.menzilString.Mobile_Number}</InputLabel>
                      <Field name="phone">
                        {({ field }) => (
                          <div className="py-2">
                            <PhoneInputComponent
                              {...field}
                              country="iq"
                              type="phone"
                              countryCodeEditable={false}
                              value={formikBag.values.whole_number}
                              // style={{
                              //     direction: defaultLanguage === "ar" ? "rtl" : "ltr",
                              //   }}
                              onChange={(phone, data) => {
                                formikBag.setFieldValue("country_code", data.format.slice(0, 1) + data.dialCode);
                                formikBag.setFieldValue("mobile_number", phone.slice(data.dialCode.length));
                              }}
                              error={formikBag.touched.mobile_number && formikBag.errors.phone ? formikBag.errors.phone : null}
                              className="form-control"
                              placeholder={dictionary.menzilString.Mobile_Number}
                            />
                          </div>
                        )}
                      </Field>
                    </div>

                    <div className="col-md-12 mt-3">
                      <InputLabel>{dictionary.menzilString.Password}</InputLabel>
                      <Field name="password">
                        {({ field }) => (
                          <div className="py-2">
                            <Input
                              {...field}
                              type="password"
                              value={formikBag.values.password}
                              onChange={(e) => {
                                formikBag.setFieldValue("password", e.target.value);
                              }}
                              error={formikBag.touched.password && formikBag.errors.password ? formikBag.errors.password : null}
                              className="form-control"
                              placeholder={dictionary.menzilString.Password}
                            />
                          </div>
                        )}
                      </Field>
                    </div>

                    <p className="login-footer-link">
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setDefaultState({
                            isLogin: false,
                            isForget: true,
                          });
                        }}
                        // href="javascript:void()"
                      >
                        {dictionary.menzilString.Forgot_Password}
                      </a>
                    </p>

                    <div className="text-center login_btn_group">
                      <LoginButton type="submit">{dictionary.menzilString.Signin}</LoginButton>
                    </div>

                    {/* <div className="d-flex justify-content-center mt-4">
                      <FormNextButton
                        onClick={() => {
                          guestLogin();
                        }}
                      >
                        Skip
                        <BsArrowRight style={{ marginLeft: "0.4rem" }} />
                      </FormNextButton>
                    </div> */}

                    {/* <PartitionSection>
                    <PartitionSectionP></PartitionSectionP>
                    <PartitionOR>or</PartitionOR>
                    <PartitionSectionP></PartitionSectionP>
                  </PartitionSection>
                    <SocialContainer>
                      <SocialBtnGoogle><SocialImg src={GoogleLogo} alt="social_logo" /></SocialBtnGoogle>
                      <SocialBtnApple><SocialImg src={AppleNewLogo} alt="social_logo" /></SocialBtnApple>
                      <SocialBtnFb><SocialImg src={FacebookNewLogo} alt="social_logo" /></SocialBtnFb>
                    </SocialContainer> */}

                    {/* <p className="text-center">
                    Create
                    <a href="javascript:void()"
                      style={{ color: "#2B3BF6" }}
                      onClick={() => {
                        setDefaultState({
                          isSignup: false,
                          isLogin: false,
                          isCheckLocation: true
                        });
                      }} >
                      &nbsp;New Account
                    </a>
                  </p> */}
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />

      {/* Sign Up Profile */}

      <Modal
        maxWidth="sm"
       
        noDialogPadding={true}
        isOpen={defaultState.isSignup}
        title={
          <LoginTitleMiddle>
            <LoginHeading>{dictionary.menzilString.Welcome_to_Menzill}</LoginHeading>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isSignup: false,
                    isLogin: false,
                  });
                }}
              />
            </div>
          </LoginTitleMiddle>
        }
        content={
          <>
            <SigninWrap>
              <SigninText
                onClick={() => {
                  setDefaultState({
                    isLogin: true,
                    isSignup: false,
                  });
                }}
              >
                {dictionary.menzilString.Signin}
              </SigninText>
              <NewAccountText
                logintype={defaultState.isSignup}
                onClick={() => {
                  setDefaultState({
                    isLogin: false,
                    isSignup: true,
                  });
                }}
              >
                {dictionary.menzilString.New_account}
              </NewAccountText>
            </SigninWrap>
            <SigninBorder></SigninBorder>
            <Formik
              enableReinitialize
              initialValues={signUpformValues}
              validate={(vals) => signUpValidator(vals, dictionary.menzilString)}
              validateOnChange
              onSubmit={handleSignUP}
            >
              {(formikBag) => {
                return (
                  <Form>
                    <div className="row">
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.First_name}</InputLabel>
                        <Field name="first_name">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                value={capitalize(formikBag.values.first_name)}
                                onChange={(e) => {
                                  formikBag.setFieldValue("first_name", e.target.value);
                                }}
                                error={
                                  formikBag.touched.first_name && formikBag.errors.first_name
                                    ? formikBag.errors.first_name
                                    : null
                                }
                                className="form-control"
                                placeholder={dictionary.menzilString.First_name}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Last_name}</InputLabel>
                        <Field name="last_name">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                value={capitalize(formikBag.values.last_name)}
                                onChange={(e) => {
                                  formikBag.setFieldValue("last_name", e.target.value);
                                }}
                                error={
                                  formikBag.touched.last_name && formikBag.errors.last_name ? formikBag.errors.last_name : null
                                }
                                className="form-control"
                                placeholder={dictionary.menzilString.Last_name}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Email_Id}</InputLabel>
                        <Field name="email">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                value={formikBag.values.email}
                                onChange={(e) => {
                                  formikBag.setFieldValue("email", e.target.value);
                                }}
                                error={formikBag.touched.email && formikBag.errors.email ? formikBag.errors.email : null}
                                className="form-control"
                                placeholder={dictionary.menzilString.Email_Id}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                      {/* <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Postal_Codes}</InputLabel>
                        <Field name="postalCode">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                value={formikBag.values.postalCode}
                                onChange={(e) => {
                                  formikBag.setFieldValue("postalCode", e.target.value);
                                }}
                                error={
                                  formikBag.touched.postalCode && formikBag.errors.postalCode
                                    ? formikBag.errors.postalCode
                                    : null
                                }
                                className="form-control"
                                placeholder={dictionary.menzilString.Postal_Codes}
                              />
                              {console.log(formikBag)}
                            </div>
                          )}
                        </Field>
                      </div> */}

                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Select_Country}</InputLabel>
                        <Field name="countryName">
                          {({ field }) => (
                            <div className="py-2">
                              <Select
                                // value={formikBag.values.countryName}
                                value={countryList?.find((option) => option.value === formikBag.values.countryName) || null}
                                options={countryList}
                                onChange={(option) => {
                                  if (option) {
                                    formikBag.setFieldValue("countryName", option.value);
                                    formikBag.setFieldValue("postalCode", "");
                                    setCountryName(option.value);
                                  }
                                  else {
                                    // Handle cancel/reset case
                                    formikBag.setFieldValue("countryName", "");
                                    formikBag.setFieldValue("postalCode", "");
                                    setCountryName("");
                                  }
                                }}
                                isSearchable
                                isClearable
                                placeholder={dictionary.menzilString.Select_Country}
                                className="custom-placeholder"
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Postal_Codes}</InputLabel>
                        <Field name="postalCode">
                          {({ field }) => (
                            <div className="py-2">
                              <Select
                                // value={formikBag.values.postalCode}
                                // value={postalCodeList?.find((option) => option.value === formikBag.values.postalCode) || null}
                                // options={postalCodeList}
                                // onChange={(option) => {
                                //   formikBag.setFieldValue("postalCode", option.value);
                                // }}
                                value={postalCodeList?.find((option) => option.value === formikBag.values.postalCode) || null}
                                options={postalCodeList || []}
                                onChange={(option) => {
                                  if (option) {
                                    formikBag.setFieldValue("postalCode", option.value);
                                  }else {
                                 
                                    formikBag.setFieldValue("postalCode", "");
                                    
                                  }
                                }}
                                isClearable
                                isSearchable
                                // className="form-control"
                                placeholder={dictionary.menzilString.Postal_Codes}

                                // error={
                                //   formikBag.touched.selectUser && formikBag.errors.selectUser ? formikBag.errors.selectUser : null
                                // }
                              />
                            </div>
                          )}
                        </Field>
                      </div>

                      <div className={"col-md-6 signup_phone" + (defaultLanguage === "ar" ? " tel-arabic" : "")}>
                        <InputLabel>{dictionary.menzilString.Mobile_Number}</InputLabel>
                        <Field name="phone">
  {({ field, form }) => (
    <div className="py-2">
      <PhoneInputComponent
        {...field}
        country="iq"
        type="phone"
        countryCodeEditable={false}
        value={form.values.whole_number}
        onChange={(phone, data) => {
          form.setFieldValue("whole_number", phone);
          form.setFieldValue("countryCode", `+${data.dialCode}`);
          form.setFieldValue("phone", phone.slice(data.dialCode.length));
        }}
        onBlur={() => {
          form.setFieldTouched("phone", true); // Manually setting touched for `phone`
        }}
        error={
          form.touched.phone && form.errors.phone
            ? form.errors.phone
            : null
        }
        className="form-control"
        placeholder={dictionary.menzilString.Mobile_Number}
      />
    </div>
  )}
</Field>

                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Password}</InputLabel>
                        <Field name="password">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="password"
                                value={formikBag.values.password}
                                onChange={(e) => {
                                  formikBag.setFieldValue("password", e.target.value);
                                }}
                                error={
                                  formikBag.touched.password && formikBag.errors.password ? formikBag.errors.password : null
                                }
                                className="form-control"
                                placeholder={dictionary.menzilString.Password}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Confirm_Password}</InputLabel>
                        <Field name="confirm_password">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="password"
                                value={formikBag.values.confirm_password}
                                onChange={(e) => {
                                  formikBag.setFieldValue("confirm_password", e.target.value);
                                }}
                                error={
                                  formikBag.touched.confirm_password && formikBag.errors.confirm_password
                                    ? formikBag.errors.confirm_password
                                    : null
                                }
                                className="form-control"
                                placeholder={dictionary.menzilString.Confirm_Password}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <InputLabel>{dictionary.menzilString.Choose_role}</InputLabel>
                      <Field name="selectUser">
                        {({ field }) => (
                          <div className="py-2">
                            <Select
                              value={formikBag.values.selectUser}
                              options={UserTypes}
                              onChange={(option) => {
                                formikBag.setFieldValue("selectUser", option);
                              }}
                              // className="form-control"
                              placeholder={dictionary.menzilString.Choose_role}
                              error={
                                formikBag.touched.selectUser && formikBag.errors.selectUser ? formikBag.errors.selectUser : null
                              }
                            />
                          </div>
                        )}
                      </Field>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <Field name="terms_check">
                          {({ field }) => (
                            <div
                              className="py-2 "
                              style={{
                                display: "flex",
                                alignItems: "center",
                                direction: defaultLanguage === "ar" ? "rtl" : "ltr",
                              }}
                            >
                              <Input
                                {...field}
                                type="checkbox"
                                // value={formikBag.values.terms_check}
                                onChange={(e) => {
                                  formikBag.setFieldValue("terms_check", !formikBag.values.terms_check);
                                }}
                                noBorderBottom={true}
                              />
                              <TermText>
                                {dictionary.menzilString.I_Accept}
                                <a href="/term-condition" className="term-link" target="_blank">
                                  {" "}
                                  {dictionary.menzilString.Terms_Conditions}{" "}
                                </a>
                                {/* <TermLink> Terms & Conditions </TermLink> */}
                                {dictionary.menzilString.and}
                                <a href="/privacy-policy" className="term-link" target="_blank">
                                  {" "}
                                  {dictionary.menzilString.Privacy_Policy}
                                </a>
                                {/* <TermLink> Privacy Policy </TermLink> */}
                              </TermText>
                            </div>
                          )}
                        </Field>
                      </div>
                      {formikBag.touched.terms_check && formikBag.errors.terms_check && (
                        <p
                          style={{
                            fontSize: 13,
                            color: "red",
                            textAlign: selectedLanguage === "ar" ? "right" : "left",
                          }}
                        >
                          {formikBag.errors.terms_check}
                        </p>
                      )}
                    </div>

                    <div className="text-center login_btn_group">
                      <LoginButton type="submit">{dictionary.menzilString.Sign_up}</LoginButton>
                    </div>

                    {/* <PartitionSection>
                    <PartitionSectionP></PartitionSectionP>
                    <PartitionOR>or</PartitionOR>
                    <PartitionSectionP></PartitionSectionP>
                  </PartitionSection>
                    <SocialContainer>
                      <SocialBtnGoogle socialSize ><SocialImg src={GoogleLogo} alt="social_logo" /></SocialBtnGoogle>
                      <SocialBtnApple socialSize ><SocialImg src={AppleNewLogo} alt="social_logo" /></SocialBtnApple>
                      <SocialBtnFb socialSize ><SocialImg src={FacebookNewLogo} alt="social_logo" /></SocialBtnFb>
                    </SocialContainer> */}

                    {/* <p className="text-center">
                    Create
                    <a href="javascript:void()"
                      style={{ color: "#2B3BF6" }}
                      onClick={() => {
                        setDefaultState({
                          isSignup: false,
                          isLogin: false,
                          isCheckLocation: true
                        });
                      }} >
                      &nbsp;New Account
                    </a>
                  </p> */}
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />

      {/* Agent Basic Details Modal */}
      <Modal
        maxWidth="sm"
        width="480px"
        noDialogPadding={true}
        isOpen={defaultState.isDetails}
        title={
          <LoginTitle>
            <LoginHeading>{dictionary.menzilString.Basic_Details}</LoginHeading>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isDetails: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <>
            <Formik
              enableReinitialize
              initialValues={detailsValues}
              validate={DetailsValidator}
              validateOnChange
              onSubmit={handleDetails}
            >
              {(formikBag) => {
                return (
                  <Form>
                    <div className="col-md-12">
                      <InputLabel>{dictionary.menzilString.Bio}</InputLabel>
                      <Field name="bio">
                        {({ field }) => (
                          <div className="py-2">
                            <TextArea
                              {...field}
                              type="text"
                              value={formikBag.values.bio}
                              onChange={(e) => {
                                formikBag.setFieldValue("bio", e.target.value);
                              }}
                              error={formikBag.touched.bio && formikBag.errors.bio ? formikBag.errors.bio : null}
                              className="form-control"
                              placeholder={dictionary.menzilString.Write_something}
                            />
                          </div>
                        )}
                      </Field>
                    </div>

                    <div className="col-md-12">
                      <InputLabel>{dictionary.menzilString.Address}</InputLabel>
                      <Field name="address">
                        {({ field }) => (
                          <div className="py-2">
                            <Input
                              {...field}
                              type="text"
                              value={formikBag.values.address}
                              onChange={(e) => {
                                formikBag.setFieldValue("address", e.target.value);
                              }}
                              error={formikBag.touched.address && formikBag.errors.address ? formikBag.errors.address : null}
                              className="form-control"
                              placeholder={dictionary.menzilString.Enter_Address}
                            />
                          </div>
                        )}
                      </Field>
                    </div>

                    <div className="col-md-12">
                      <InputLabel>{dictionary.menzilString.Licence_Number}</InputLabel>
                      <Field name="license_number">
                        {({ field }) => (
                          <div className="py-2">
                            <Input
                              {...field}
                              type="text"
                              value={formikBag.values.license_number}
                              onChange={(e) => {
                                formikBag.setFieldValue("license_number", e.target.value);
                              }}
                              error={
                                formikBag.touched.license_number && formikBag.errors.license_number
                                  ? formikBag.errors.license_number
                                  : null
                              }
                              className="form-control"
                              placeholder={dictionary.menzilString.Enter_Licence_Number}
                            />
                          </div>
                        )}
                      </Field>
                    </div>
                    <WebsiteText>{dictionary.menzilString.Add_websites}</WebsiteText>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Website_Name}</InputLabel>
                        <Field name="website_name">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                // value={formikBag.values.password}
                                // onChange={(e) => {
                                //   formikBag.setFieldValue("password", e.target.value);
                                // }}
                                // error={
                                //   formikBag.touched.password &&
                                //     formikBag.errors.password
                                //     ? formikBag.errors.password
                                //     : null
                                // }
                                className="form-control"
                                placeholder={dictionary.menzilString.Blogs}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="col-md-6">
                        <InputLabel>{dictionary.menzilString.Website_Link}</InputLabel>
                        <Field name="website_link">
                          {({ field }) => (
                            <div className="py-2">
                              <Input
                                {...field}
                                type="text"
                                // value={formikBag.values.password}
                                // onChange={(e) => {
                                //   formikBag.setFieldValue("password", e.target.value);
                                // }}
                                // error={
                                //   formikBag.touched.password &&
                                //     formikBag.errors.password
                                //     ? formikBag.errors.password
                                //     : null
                                // }
                                className="form-control"
                                placeholder={dictionary.menzilString.http_text}
                              />
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>

                    <MoreWebsiteButton>
                      <MoreWebsiteText>{dictionary.menzilString.Add_more_website}</MoreWebsiteText>
                    </MoreWebsiteButton>

                    <div className="text-center login_btn_group">
                      <LoginButton type="submit">{dictionary.menzilString.Continue}</LoginButton>
                    </div>

                    {/* <p className="text-center">
                    Create
                    <a href="javascript:void()"
                      style={{ color: "#2B3BF6" }}
                      onClick={() => {
                        setDefaultState({
                          isSignup: false,
                          isLogin: false,
                          isCheckLocation: true
                        });
                      }} >
                      &nbsp;New Account
                    </a>
                  </p> */}
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />

      {/* Reset Modal */}

      <Modal
        isOpen={defaultState.isReset}
        width="480px"
        noDialogPadding={true}
        title={
          <LoginTitle>
            <LoginDetails>
              <LoginHeading>{dictionary.menzilString.Reset_Password} </LoginHeading>
              <ForgePara>
                {dictionary.menzilString.Set_the_new_password} <br /> {dictionary.menzilString.access_all_features}
              </ForgePara>
            </LoginDetails>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isReset: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <Formik
            enableReinitialize
            initialValues={resetPasswordValues}
            validate={(values) => resetOutValidator(values)}
            validateOnChange
            onSubmit={handleReset}
          >
            {(formikBag) => {
              return (
                <Form>
                  <Field name="password">
                    {({ field }) => (
                      <div className="py-2">
                        <Input
                          {...field}
                          type="password"
                          value={formikBag.values.password}
                          onChange={(e) => {
                            formikBag.setFieldValue("password", e.target.value);
                          }}
                          error={formikBag.touched.password && formikBag.errors.password ? formikBag.errors.password : null}
                          className="form-control"
                          placeholder={dictionary.menzilString.New_Password}
                        />
                      </div>
                    )}
                  </Field>
                  <Field name="confirm_password">
                    {({ field }) => (
                      <div className="py-2">
                        <Input
                          {...field}
                          // type="confirm_password"
                          value={formikBag.values.confirm_password}
                          onChange={(e) => {
                            formikBag.setFieldValue("confirm_password", e.target.value);
                          }}
                          type="password"
                          error={
                            formikBag.touched.confirm_password && formikBag.errors.confirm_password
                              ? formikBag.errors.confirm_password
                              : null
                          }
                          className="form-control"
                          placeholder={dictionary.menzilString.Confirm_Password}
                        />
                      </div>
                    )}
                  </Field>

                  <div className="py-3 text-center">
                    <LoginButton type="submit">{dictionary.menzilString.Continue}</LoginButton>
                  </div>
                </Form>
              );
            }}
          </Formik>
        }
      />

      {/* Otp Modal */}
      <Modal
        isOpen={defaultState.isOtp}
        maxWidth="md"
        // width="480px"
        noDialogPadding={true}
        title={
          <LoginTitle>
            <LoginDetails>
              <LoginHeading>{dictionary.menzilString.Enter_OTP}</LoginHeading>
              <LoginPara>
                {dictionary.menzilString.We_have_sent_you_a_4_digit_verification_code_on} <br />{" "}
                {dictionary.menzilString.code_on}{" "}
                <span style={{ color: "#004CFF" }}>
                  {defaultLanguage === "ar"
                    ? otpPhone.mobile_number + " " + `${otpPhone.country_code?.slice(1)}+`
                    : otpPhone.country_code + " " + otpPhone.mobile_number}
                </span>{" "}
              </LoginPara>
            </LoginDetails>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isOtp: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <>
            <Formik
              enableReinitialize
              initialValues={OTPFormValues}
              validate={(vals) => otpValidator(vals, dictionary.menzilString)}
              validateOnChange
              onSubmit={verifyOTP}
            >
              {(formikBag) => {
                return (
                  <Form>
                    <div className="signup-cont">
                      <div className={"otp_input" + (defaultLanguage === "ar" ? " otp-arabic" : "")}>
                        <OtpInput
                          value={formikBag.values.verification_code}
                          onChange={(e) => formikBag.setFieldValue("verification_code", e)}
                          numInputs={4}
                          isInputNum={true}
                          // style={{ direction: defaultLanguage === "ar" ? "rtl" : "ltr" }}
                        />
                      </div>
                      {formikBag.errors.verification_code ? (
                        <p
                          style={{
                            paddingTop: 5,
                            fontSize: 13,
                            color: "red",
                            textAlign: "center",
                          }}
                        >
                          {formikBag.errors.verification_code}
                        </p>
                      ) : null}

                      <div className="pt-2 pb-4 d-flex justify-content-start">
                        <LoginButton type="submit">{dictionary.menzilString.Continue}</LoginButton>
                      </div>
                      <div
                        className="login-footer text-center"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {" "}
                        <div>{dictionary.menzilString.Didnt_receive_OTP_Resend_OTP}&nbsp;&nbsp;</div>
                        <div>
                          <Countdown date={Date.now() + 15000} renderer={renderer} key={otpKey} />
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />

      {/* ForgetOtp Modal */}
      <Modal
        isOpen={defaultState.isForgetOtp}
        maxWidth="md"
        // width="480px"
        noDialogPadding={true}
        title={
          <LoginTitle>
            <LoginDetails>
              <LoginHeading>{dictionary.menzilString.Forgot_Password}</LoginHeading>
              <LoginPara>
                {dictionary.menzilString.We_have_sent_you_a_4_digit_verification_code_on} <br />{" "}
                {dictionary.menzilString.code_on}{" "}
                <span style={{ color: "#004CFF" }}>
                  {defaultLanguage === "ar"
                    ? otpPhone.mobile_number + " " + `${otpPhone.country_code?.slice(1)}+`
                    : otpPhone.country_code + " " + otpPhone.mobile_number}
                </span>{" "}
              </LoginPara>
            </LoginDetails>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isOtp: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <>
            <Formik
              enableReinitialize
              initialValues={OTPFormValues}
              validate={otpValidator}
              validateOnChange
              onSubmit={forgetVerifyOTP}
            >
              {(formikBag) => {
                return (
                  <Form>
                    <div className="signup-cont">
                      <div className={"otp_input" + (defaultLanguage === "ar" ? " otp-arabic" : "")}>
                        <OtpInput
                          value={formikBag.values.verification_code}
                          onChange={(e) => formikBag.setFieldValue("verification_code", e)}
                          numInputs={4}
                          isInputNum={true}
                          style={{ direction: defaultLanguage === "ar" ? "rtl" : "ltr" }}
                        />
                      </div>
                      {formikBag.errors.verification_code ? (
                        <p
                          style={{
                            paddingTop: 5,
                            fontSize: 13,
                            color: "red",
                            textAlign: "center",
                          }}
                        >
                          {formikBag.errors.verification_code}
                        </p>
                      ) : null}

                      <div className="pt-2 pb-4 d-flex justify-content-start">
                        <LoginButton type="submit">{dictionary.menzilString.Continue}</LoginButton>
                      </div>
                      <div
                        className="login-footer text-center"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {" "}
                        <div>{dictionary.menzilString.Didnt_receive_OTP_Resend_OTP}&nbsp;&nbsp;</div>
                        <div>
                          <Countdown date={Date.now() + 15000} renderer={renderer} key={otpKey} />
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />

      {/* Forget Modal */}

      <Modal
        isOpen={defaultState.isForget}
        maxWidth="md"
        width="470px"
        noDialogPadding={true}
        title={
          <LoginTitle>
            <LoginDetails>
              <ForgetHeading>{dictionary.menzilString.Forgot_Password}</ForgetHeading>
              <ForgetPara>{dictionary.menzilString.Enter_your_registered_mobile_number}</ForgetPara>
            </LoginDetails>
            <div className={"closeicon" + (defaultLanguage === "ar" ? " arabb" : "")}>
              <AiOutlineClose
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  setDefaultState({
                    isForget: false,
                  });
                }}
              />
            </div>
          </LoginTitle>
        }
        content={
          <Formik
            enableReinitialize
            initialValues={{
              country_code: "",
              mobile_number: "",
            }}
            validate={(vals) => forgetValidator(vals, dictionary.menzilString)}
            validateOnChange
            onSubmit={(values) =>
              sendForgetOTP(
                {
                  country_code: values.country_code,
                  mobile_number: values.mobile_number,
                },
                true
              )
            }
          >
            {(formikBag) => {
              return (
                <Form>
                  <div className={"col-md-12 signup_phone" + (defaultLanguage === "ar" ? " tel-arabic" : "")}>
                    <InputLabel>{dictionary.menzilString.Mobile_Number}</InputLabel>
                    <Field name="phone">
                      {({ field }) => (
                        <div className="py-2">
                          <PhoneInputComponent
                            {...field}
                            country="iq"
                            type="phone"
                            countryCodeEditable={false}
                            value={formikBag.values.whole_number}
                            onChange={(phone, data) => {
                              formikBag.setFieldValue("country_code", data.format.slice(0, 1) + data.dialCode);
                              formikBag.setFieldValue("mobile_number", phone.slice(data.dialCode.length));
                            }}
                            error={formikBag.touched.mobile_number && formikBag.errors.phone ? formikBag.errors.phone : null}
                            className="form-control"
                            placeholder={dictionary.menzilString.Mobile_Number}
                          />
                        </div>
                      )}
                    </Field>
                  </div>

                  <div className="text-center login_btn_group">
                    <LoginButton type="submit">{dictionary.menzilString.Get_OTP}</LoginButton>
                  </div>
                </Form>
              );
            }}
          </Formik>
        }
      />

      <CustomModal
        isOpen={defaultState.isAgentPrescription}
        onClose={() => {
          setDefaultState({
            isAgentPrescription: false,
          });
        }}
        size="s"
      >
        <Flex fd="v" ai="c">
          <ApprovalBox>
            <Lottie animationData={sadAnimation} loop={true} style={{ width: "20%" }} />
            <ApprovalText style={{ marginTop: "1rem", fontSize: "1.2rem" }}>
              {dictionary.menzilString.Sorry_for_inconvenience}
            </ApprovalText>
            <PurchaseDesc style={{ marginTop: "0.6rem" }}>
              {dictionary.menzilString.Please_purchase_the_prescription}
            </PurchaseDesc>
            <PurchaseDesc>{dictionary.menzilString.to_Post_a_Property}</PurchaseDesc>
            <PurchaseDesc>{dictionary.menzilString.check_seller_details}</PurchaseDesc>
            <ApprovalButton
              className="d-flex justify-content-center"
              style={{ width: "50%" }}
              onClick={() => {
                history.push("/prescription");
                setDefaultState({ isAgentPrescription: false });
              }}
            >
              <LoginButton
                style={{ color: "#FFFFFF", background: "#004CFF", border: "1px solid #004CFF", borderRadius: "6px" }}
              >
                {dictionary.menzilString.Purchase_Now}
              </LoginButton>
            </ApprovalButton>
            <NotText
              onClick={() => {
                history.push("/");
                setDefaultState({ isAgentPrescription: false });
              }}
            >
              {dictionary.menzilString.Not_Now}
            </NotText>
          </ApprovalBox>
        </Flex>
      </CustomModal>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    notificationDataState: state.notificationData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar));
